import React from 'react';

import * as colors from 'lib/Colors';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

export interface AssemblyPreviewProps {
  fragmentSequenceNames: Array<string | undefined>;
  snapshotURL: string;
}

export function AssemblyPreview({fragmentSequenceNames, snapshotURL}: AssemblyPreviewProps): JSX.Element {
  return (
    <fieldset>
      <legend>Assembly Preview</legend>
      <Row>
        <Col xs={8}>
          <img src={snapshotURL} />
        </Col>
        <Col xs={4}>
          <table className="table table-condensed table-hover">
            <thead>
              <tr>
                <th>Parent Sequence</th>
              </tr>
            </thead>
            <tbody>
              {fragmentSequenceNames.map((name, i) => (
                <tr key={i}>
                  <td className="printable-color" style={{borderLeftColor: colors.shuffledPastelColors[i]}}>
                    {name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </fieldset>
  );
}
